"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createQuestion = void 0;
var _constants = require("../../../../utils/constants");
var _ChoicesQuestion = _interopRequireDefault(require("./ChoicesQuestion"));
var _MultiQuestion = _interopRequireDefault(require("./MultiQuestion"));
var _BaseQuestion = _interopRequireDefault(require("./BaseQuestion"));
var _AddressSearchQuestion = _interopRequireDefault(require("./AddressSearchQuestion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var createQuestion = function createQuestion(questionType, context) {
  switch (questionType) {
    case _constants.QUESTION_TYPE.CHOICES:
      return new _ChoicesQuestion.default(context);
    case _constants.QUESTION_TYPE.RANGE:
      return new _BaseQuestion.default(context);
    case _constants.QUESTION_TYPE.SEARCH:
      return new _BaseQuestion.default(context);
    case _constants.QUESTION_TYPE.ADDRESS_SEARCH:
      return new _AddressSearchQuestion.default(context);
    case _constants.QUESTION_TYPE.MULTI:
      return new _MultiQuestion.default(context);
    case _constants.QUESTION_TYPE.IMAGE:
      return new _ChoicesQuestion.default(context);
    default:
      throw Error("Unsupported question type '".concat(questionType, "'"));
  }
};
exports.createQuestion = createQuestion;